import { ApiResult, request, safeRequest } from '@synergy/api';

export class SearchHistoryApi {
    constructor(protected baseUrl: string) {}

    public getUserSearchHistory(): Promise<ApiResult<string[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/search-history`),
            response => response.data
        );
    }

    public clearUserSearchHistory(): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/search-history/clear`),
            response => response.data
        );
    }
}
